import type { SVGProps } from 'react';
const SvgConversationalSearchAi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 34 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.419 5.933 17.658.846l-1.761 5.087-5.283 1.696 5.283 1.696 1.76 5.087 1.762-5.087L24.7 7.629zm9.509 12.549-1.41-4.07-1.408 4.07-4.226 1.356 4.226 1.357 1.409 4.07 1.409-4.07 4.226-1.357zM5.266 14.37H6.37c.61 0 1.105.52 1.105 1.163v1.163H4.16v-1.163c0-.643.494-1.162 1.105-1.162m2.206 3.489v12.685c0 .701-.493 1.268-1.104 1.268H1.95c-.61 0-1.104-.567-1.104-1.268V28.2c0-1.372.325-2.72.939-3.897.473-.903.776-1.91.89-2.957l.259-2.378c.07-.635.538-1.11 1.097-1.11h3.445zm8.974 0c.556 0 1.03.475 1.098 1.11l.256 2.378a8.3 8.3 0 0 0 .89 2.957 8.45 8.45 0 0 1 .94 3.897v2.343c0 .701-.494 1.268-1.105 1.268h-4.42c-.611 0-1.105-.567-1.105-1.268V17.859zM13 15.533c0-.643.494-1.162 1.105-1.162h1.105c.611 0 1.105.52 1.105 1.162v1.163H13zm-1.105 2.326v6.977h-2.21v-6.977z"
    />
  </svg>
);
export default SvgConversationalSearchAi;
